import { Text } from "@/components/ui/text";
import { Button } from "@/components/ui/button";
import { HStack } from "@/components/ui/hstack";
import { Input, InputField } from "@/components/ui/input";
import React, { useEffect, useState } from 'react';
import { IconM } from '../media/IconsV2';

export default function TimerInput({ timer, updateTimer }) {
    const [hours, setHours] = useState(Math.min(Math.floor(timer / 3600), 12))
    const [minutes, setMinutes] = useState(Math.min(Math.floor((timer % 3600) / 60), 59))
    const [seconds, setSeconds] = useState(Math.min(Math.floor((timer % 3600) % 60), 59))

    useEffect(() => {
        const newTimer = hours * 3600 + minutes * 60 + seconds;
        if (newTimer != timer) {
            console.log('UPDATE', timer, newTimer)
            updateTimer(newTimer)
        }
    }, [hours, minutes, seconds])

    console.log('HI', timer, hours, minutes, seconds)
    return (
        <HStack space={1} className="items-center mb-3">
            <Input className="w-[80px] h-[60px]">
                <InputField maxLength={2} variant='filled' placeholder='00' value={hours} keyboardType={'number-pad'} onChangeText={text => setHours(Math.min(parseInt(text) || 0, 12))} selectionColor={"#D2D4D7"} className="font-Assistant text-4xl leading-3xl font-[700] text-secondary-900 bg-transparent pt-2 text-center" />
            </Input>
            <Text bold className="text-black pb-2 text-4xl leading-4xl">:</Text>
            <Input className="w-[80px] h-[60px]">
                <InputField maxLength={2} variant='filled' placeholder='00' value={minutes} keyboardType={'number-pad'} onChangeText={text => setMinutes(Math.min(parseInt(text) || 0, 59))} selectionColor={"#D2D4D7"} className="font-Assistant text-4xl leading-3xl font-[700] text-secondary-900 bg-transparent pt-2 text-center" />
            </Input>
            <Text bold className="text-black pb-2 text-4xl leading-4xl">:</Text>
            <Input className="w-[80px] h-[60px]">
                <InputField maxLength={2} variant='filled' placeholder='00' value={seconds} keyboardType={'number-pad'} onChangeText={text => setSeconds(Math.min(parseInt(text) || 0, 59))} selectionColor={"#D2D4D7"} className="font-Assistant text-4xl leading-3xl font-[700] text-secondary-900 bg-transparent pt-2 text-center" />
            </Input>
            <Button onPress={() => {
                setHours(0)
                setMinutes(0)
                setSeconds(0)
            }} className="bg-transparent">
                <IconM className="text-3xl text-primary-900" name='clear' />
            </Button>
        </HStack>
    );
}
